import React from 'react';
import {
    BlockWrapper,
    CPSettingsBlockWrapper,
    SettingsBlockHeader,
    SettingsBlockTitle
} from "pages/settings/settingsPageStyles";
import SPList from './SPList';
import {useAppSelector} from "hooks/redux";
import Loader from "components/Loader/Loader";

function SpSettingsBlock() {
    const {MDPSelectedItem, loading} = useAppSelector(state => state.settings)
    return (
        <CPSettingsBlockWrapper>
            <SettingsBlockHeader>
                <SettingsBlockTitle>
                    SP: {MDPSelectedItem.SPname?.replace("::copy", "")}
                </SettingsBlockTitle>
            </SettingsBlockHeader>
            <BlockWrapper>
                {loading && <Loader size="large" />}
                
                {!loading &&  <SPList />}
            </BlockWrapper>
        </CPSettingsBlockWrapper>
    );
}

export default SpSettingsBlock;
